/* Obraz na vlastní fotce zdi, se kterým jde hýbat (2026-09-19).

   PROČ TAKHLE: dřív server vrátil hotový složený obrázek. Vážil megabajty
   a hlavně — když AI místo trefila špatně, nedalo se s tím už nic dělat,
   protože obraz byl do fotky zapečený. Měřeno na skutečné fotce majitelky
   skončil obraz přes závěs a žádný z vyzkoušených modelů to nesvedl líp.

   Majitelka: „přestat hádat a nechat to dodělat člověka." AI tedy jen navrhne
   místo a návštěvník si obraz posune prstem a dvěma prsty zvětší.

   Fotka se nikam neposílá a nestahuje zpátky — prohlížeč ji má od chvíle, kdy
   ji návštěvník vybral. Ze serveru chodí jen souřadnice zdi, pár set bajtů.

   Poloha se drží ve zlomcích fotky (střed X, střed Y, šířka), ne v pixelech:
   fotka se zobrazuje pokaždé jinak velká podle šířky okna a v pixelech by
   obraz při otočení telefonu odskočil. */
(function () {
  'use strict';

  // Meze zvětšení. Pod osm procent by obraz byl k nepoznání, nad devadesát
  // pět už by nešlo poznat, co je na fotce pod ním.
  var MIN_SIRKA = 0.08;
  var MAX_SIRKA = 0.95;

  function omez(v, min, max) {
    return Math.min(max, Math.max(min, v));
  }

  function vytvor(kontejner, volby) {
    var dila = (volby && volby.dila) || [];
    if (!kontejner || !volby || !volby.fotkaUrl || !dila.length) return null;

    var texty = volby.texty || {};
    var poradi = 0;
    var posunuto = false;

    kontejner.innerHTML = '';
    kontejner.classList.add('scena-obal');

    var plocha = document.createElement('div');
    plocha.className = 'scena';

    var foto = document.createElement('img');
    foto.className = 'scena-foto';
    foto.src = volby.fotkaUrl;
    foto.alt = texty.fotkaAlt || '';
    plocha.appendChild(foto);

    var ramecek = document.createElement('div');
    ramecek.className = 'scena-obraz';
    ramecek.setAttribute('role', 'img');

    var obraz = document.createElement('img');
    obraz.decoding = 'async';
    ramecek.appendChild(obraz);
    plocha.appendChild(ramecek);

    // Výchozí poloha, dokud nedorazí návrh ze serveru: střed fotky, o kus
    // výš (tak obrazy visí) a rozumná šířka. Návštěvník tak může hýbat hned,
    // ne až za pět sekund.
    var stav = { x: 0.5, y: 0.42, sirka: 0.34 };

    function vykresli() {
      ramecek.style.left = (stav.x * 100).toFixed(2) + '%';
      ramecek.style.top = (stav.y * 100).toFixed(2) + '%';
      ramecek.style.width = (stav.sirka * 100).toFixed(2) + '%';
    }

    function zlomekObrazu() {
      var sirkaPlochy = plocha.clientWidth || 1;
      var vyskaPlochy = plocha.clientHeight || 1;
      return {
        w: ramecek.offsetWidth / sirkaPlochy,
        h: ramecek.offsetHeight / vyskaPlochy
      };
    }

    // Obraz smí přesahovat přes okraj jen z poloviny — kdyby se dal vytáhnout
    // úplně ven, návštěvník by ho ztratil a nevěděl by, kam sáhnout.
    function srovnejDoPlochy() {
      var z = zlomekObrazu();
      stav.x = omez(stav.x, z.w * 0.25, 1 - z.w * 0.25);
      stav.y = omez(stav.y, z.h * 0.25, 1 - z.h * 0.25);
    }

    function nastavDilo(i) {
      var d = dila[i];
      if (!d) return;
      poradi = i;
      obraz.src = d.image;
      obraz.alt = d.title || '';
      ramecek.setAttribute('aria-label', d.title || '');
      // Na stránce díla je konfigurátor hned pod tím, takže tlačítko nemá kam
      // vést — tam se scéna staví bez adresy a tlačítko se schová.
      if (koupit) {
        var maKam = !!(d.url && texty.koupit);
        koupit.hidden = !maKam;
        if (maKam) {
          koupit.href = d.url;
          koupit.textContent = texty.koupit;
        }
      }
      Array.prototype.forEach.call(prepinac ? prepinac.children : [], function (b, k) {
        b.setAttribute('aria-pressed', k === i ? 'true' : 'false');
      });
    }

    /* ------------------------------------------------- posouvání a zvětšení */

    var prsty = {};
    var rozestup0 = 0;
    var sirka0 = 0;

    function stred(seznam) {
      var sx = 0, sy = 0;
      seznam.forEach(function (p) { sx += p.x; sy += p.y; });
      return { x: sx / seznam.length, y: sy / seznam.length };
    }

    function seznamPrstu() {
      return Object.keys(prsty).map(function (k) { return prsty[k]; });
    }

    ramecek.addEventListener('pointerdown', function (e) {
      ramecek.setPointerCapture(e.pointerId);
      prsty[e.pointerId] = { x: e.clientX, y: e.clientY };
      var s = seznamPrstu();
      if (s.length === 2) {
        rozestup0 = Math.hypot(s[0].x - s[1].x, s[0].y - s[1].y) || 1;
        sirka0 = stav.sirka;
      }
      ramecek.classList.add('je-drzeny');
      e.preventDefault();
    });

    ramecek.addEventListener('pointermove', function (e) {
      if (!prsty[e.pointerId]) return;
      var predtim = seznamPrstu();
      var stredPred = stred(predtim);
      prsty[e.pointerId] = { x: e.clientX, y: e.clientY };
      var ted = seznamPrstu();

      if (ted.length >= 2) {
        var r = Math.hypot(ted[0].x - ted[1].x, ted[0].y - ted[1].y) || 1;
        stav.sirka = omez(sirka0 * (r / rozestup0), MIN_SIRKA, MAX_SIRKA);
      }

      var stredTed = stred(ted);
      var sirkaPlochy = plocha.clientWidth || 1;
      var vyskaPlochy = plocha.clientHeight || 1;
      stav.x += (stredTed.x - stredPred.x) / sirkaPlochy;
      stav.y += (stredTed.y - stredPred.y) / vyskaPlochy;

      posunuto = true;
      srovnejDoPlochy();
      vykresli();
      e.preventDefault();
    });

    function pust(e) {
      delete prsty[e.pointerId];
      if (!seznamPrstu().length) ramecek.classList.remove('je-drzeny');
    }
    ramecek.addEventListener('pointerup', pust);
    ramecek.addEventListener('pointercancel', pust);

    // Na počítači se zvětšuje kolečkem. `passive: false` proto, aby šlo
    // zastavit rolování stránky pod kurzorem.
    plocha.addEventListener('wheel', function (e) {
      if (!e.ctrlKey && Math.abs(e.deltaY) < 2) return;
      stav.sirka = omez(stav.sirka * (1 - e.deltaY * 0.0015), MIN_SIRKA, MAX_SIRKA);
      posunuto = true;
      srovnejDoPlochy();
      vykresli();
      e.preventDefault();
    }, { passive: false });

    /* ------------------------------------------------- spodní ovládání */

    var napoveda = document.createElement('p');
    napoveda.className = 'scena-napoveda';
    napoveda.textContent = texty.napoveda || '';

    var prepinac = null;
    if (dila.length > 1) {
      prepinac = document.createElement('div');
      prepinac.className = 'scena-prepinac';
      dila.forEach(function (d, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'scena-volba';
        b.setAttribute('aria-pressed', 'false');
        var n = document.createElement('img');
        n.src = d.image;
        n.alt = d.title || '';
        n.loading = 'lazy';
        b.appendChild(n);
        b.addEventListener('click', function () { nastavDilo(i); });
        prepinac.appendChild(b);
      });
    }

    var koupit = document.createElement('a');
    koupit.className = 'button scena-koupit';

    kontejner.appendChild(plocha);
    kontejner.appendChild(napoveda);
    if (prepinac) kontejner.appendChild(prepinac);
    kontejner.appendChild(koupit);

    nastavDilo(0);
    vykresli();

    // Poměr stran se zná až po načtení díla; do té doby by byl rámeček plochý.
    obraz.addEventListener('load', function () {
      if (obraz.naturalWidth && obraz.naturalHeight) {
        ramecek.style.setProperty('--pomer', obraz.naturalWidth + ' / ' + obraz.naturalHeight);
      }
      srovnejDoPlochy();
      vykresli();
    });

    window.addEventListener('resize', function () {
      srovnejDoPlochy();
      vykresli();
    });

    return {
      /**
       * Přesune obraz na místo, které navrhla AI. Když už s ním návštěvník
       * hýbal, nechá ho být — jeho volba je víc než náš odhad.
       */
      navrhni: function (zed) {
        if (posunuto || !zed) return;
        var sirkaZdi = (zed.wPct || 0) / 100;
        var vyskaZdi = (zed.hPct || 0) / 100;
        if (sirkaZdi <= 0 || vyskaZdi <= 0) return;

        // Uvnitř nalezené plochy se nechá okraj, ať obraz nekončí těsně
        // u hrany nábytku nebo v rohu.
        var sirka = sirkaZdi * 0.8;
        var z = zlomekObrazu();
        var pomerPlochy = z.w > 0 ? z.h / z.w : 1.3;
        if (sirka * pomerPlochy > vyskaZdi * 0.8) {
          sirka = (vyskaZdi * 0.8) / pomerPlochy;
        }
        stav.sirka = omez(sirka, 0.22, 0.52);
        stav.x = ((zed.xPct || 0) + (zed.wPct || 0) / 2) / 100;
        stav.y = ((zed.yPct || 0) + (zed.hPct || 0) * 0.45) / 100;
        // Obrazy visí ve výšce očí, ne u stropu — nalezená hladká plocha je
        // ale často právě strop, protože tam nic není.
        stav.y = omez(stav.y, 0.26, 0.56);
        srovnejDoPlochy();
        vykresli();
      },

      znic: function () {
        kontejner.innerHTML = '';
        kontejner.classList.remove('scena-obal');
      }
    };
  }

  window.GalelieScena = { vytvor: vytvor };
})();
